/* eslint-disable react/prop-types */
import { chekOffer } from "@/common/announcement-helper";
import CorrelatedAnnouncementListComponent from "./correlated-announcement-list";

function CorrelatedAnnouncementList({
  announcements,
  admin,
  className,
  offer,
}) {
  return (
    <CorrelatedAnnouncementListComponent
      announcements={chekOffer(announcements, offer?.correlatedAnnouncements)}
      admin={admin}
      className={className}
      offer={offer}
    />
  );
}

export default CorrelatedAnnouncementList;
